import { ToastBody, Button, ToastTitle, Toast } from "@fluentui/react-components";
import { createElement } from "react";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { ContextMsg } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray, singleton } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";

/**
 * Success toast that works globally
 */
export function successToast(setCtx, toastId, title, description) {
    let el_6, elems, el_2, el, el_4;
    setCtx(new ContextMsg(0, [[(el_6 = Toast, createElement(el_6, createObj(singleton((elems = [(el_2 = ToastTitle, createElement(el_2, {
        action: (el = Button, createElement(el, {
            children: "Ok",
            onClick: (_arg) => {
                setCtx(new ContextMsg(1, [toastId]));
            },
        })),
        children: title,
    })), (el_4 = ToastBody, createElement(el_4, {
        children: description,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))), ofArray([["timeout", 5000], ["politeness", "polite"], ["intent", "success"], ["toastId", toastId]])]]));
}

/**
 * Info toast that works globally.
 */
export function infoToast(setCtx, toastId, title, description, subDescription) {
    let el_6, elems, el_2, el, el_4;
    setCtx(new ContextMsg(0, [[(el_6 = Toast, createElement(el_6, createObj(singleton((elems = [(el_2 = ToastTitle, createElement(el_2, {
        action: (el = Button, createElement(el, {
            children: "Ok",
            onClick: (_arg) => {
                setCtx(new ContextMsg(1, [toastId]));
            },
        })),
        children: title,
    })), (el_4 = ToastBody, createElement(el_4, createObj(toList(delay(() => append(singleton_1(["children", description]), delay(() => {
        const matchValue = subDescription;
        if (matchValue != null) {
            return singleton_1(["subtitle", matchValue]);
        }
        else {
            return empty();
        }
    })))))))], ["children", reactApi.Children.toArray(Array.from(elems))]))))), ofArray([["timeout", 5000], ["politeness", "polite"], ["intent", "info"], ["toastId", toastId]])]]));
}

/**
 * Warning toast that works globally.
 */
export function warningToast(setCtx, toastId, title, description, subDescription) {
    let el_4, elems, el, el_2;
    return setCtx(new ContextMsg(0, [[(el_4 = Toast, createElement(el_4, createObj(singleton((elems = [(el = ToastTitle, createElement(el, {
        children: title,
    })), (el_2 = ToastBody, createElement(el_2, createObj(toList(delay(() => append(singleton_1(["children", description]), delay(() => {
        const matchValue = subDescription;
        if (matchValue != null) {
            return singleton_1(["subtitle", matchValue]);
        }
        else {
            return empty();
        }
    })))))))], ["children", reactApi.Children.toArray(Array.from(elems))]))))), ofArray([["timeout", 10000], ["politeness", "polite"], ["intent", "warning"], ["toastId", toastId]])]]));
}

/**
 * Error toast that works globally.
 */
export function errorToast(setCtx, toastId, title, description, subDescription) {
    let el_6, elems, el_2, el, el_4;
    setCtx(new ContextMsg(0, [[(el_6 = Toast, createElement(el_6, createObj(singleton((elems = [(el_2 = ToastTitle, createElement(el_2, {
        action: (el = Button, createElement(el, {
            children: "Ok",
            onClick: (_arg) => {
                setCtx(new ContextMsg(1, [toastId]));
            },
        })),
        children: title,
    })), (el_4 = ToastBody, createElement(el_4, createObj(toList(delay(() => append(singleton_1(["children", description]), delay(() => {
        const matchValue = subDescription;
        if (matchValue != null) {
            return singleton_1(["subtitle", matchValue]);
        }
        else {
            return empty();
        }
    })))))))], ["children", reactApi.Children.toArray(Array.from(elems))]))))), ofArray([["timeout", 5000], ["politeness", "assertive"], ["intent", "error"], ["toastId", toastId]])]]));
}

//# sourceMappingURL=Toasts.jsx.map
